export default "__VITE_ASSET__CK6ZmC1f__"